import { useMutation, useQueryClient } from "@tanstack/react-query";
import useSelectedStores from "@lib/hooks/use-selected-stores";
import type { Dashboard } from "@lib/types/dashboards";
import {
  createDashboardWithRemovedInsight,
  invalidateDashboardQueries,
  updateDashboardOnServer,
} from "./utils";

export function useRemoveInsightFromDashboard() {
  const queryClient = useQueryClient();
  const { selectedOrganisation } = useSelectedStores();

  return useMutation({
    mutationFn: async ({
      dashboard,
      insightId,
    }: {
      dashboard: Dashboard;
      insightId: string;
    }) => {
      if (!selectedOrganisation) {
        throw new Error("Organisation ID is required");
      }

      return updateDashboardOnServer(
        selectedOrganisation,
        dashboard.id,
        createDashboardWithRemovedInsight(dashboard, insightId)
      );
    },
    onSuccess: async (updatedDashboard) => {
      await invalidateDashboardQueries(
        queryClient,
        selectedOrganisation,
        updatedDashboard.id
      );
    },
  });
}
